import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import * as moment from 'moment';
import classNames from 'classnames';
import { Buscar } from '../../services/contratos';
import { ProgressSpinner } from 'primereact/progressspinner';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

export class ContratosRecebidos extends Component {
    constructor() {
        super();
        this.state = {
            cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue,
            contratos:  [
                { Inscricao: '213',
                    Nome:'João da Silva',
                    DataVenda: '10-09-2020',
                    DataPagamento: '10-09-2020',
                    Processo: '234',
                    status: 1 }

            ],
            selectedRegistros: null,
            selectedStatus: null,
            submit: false,
            loading: 'loading'

        };
        this.statuses = [
            'Ativo', 'Suspenso', 'Cancelado'
        ];
    }

    componentDidMount() {
        this.setState({ loading: 'nada',
            submit: true });
        this.setState({ cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue });

        Buscar(this.state.cod).then(response => {
            if(response.length > 0){
                for(let i=0; i < response.length; i++){
                    response[i].Data = moment(response[i].Data).add(3, 'hours').format('DD-MM-YYYY');

                    if(response[i].status === 1)
                    {response[i].status = 'Ativo';}

                    if(response[i].status === 2)
                    {response[i].status = 'Suspenso';}

                    if(response[i].status === 3){
                        response[i].status = 'Cancelado';
                    } else{
                        response.status = '';
                    }
                }

                this.setState({ contratos: response });
                this.setState({ loading: 'loading',
                    submit: false });
            }
        }).catch(erro => {
            //this.setState({ loading: 'loading', submit: false });
        });
    }

    statusBodyTemplate = rowData => <span className={classNames('customer-badge', `status-${  rowData.status}` )}>
        {rowData.status }
    </span>

    statusItemTemplate = option => (
        <span className={classNames('customer-badge', `status-${  option}` )}>{option}</span>
    )

    onStatusFilterChange = event => {
        this.dt.filter(event.value, 'status', 'equals');
        this.setState({ selectedStatus: event.value });
    }

    renderStatusFilter() {
        return (
            <Dropdown value={this.state.selectedStatus} options={this.statuses} onChange={this.onStatusFilterChange}
                itemTemplate={this.statusItemTemplate} showClear={true} placeholder="Select a Status" className="p-column-filter"/>
        );
    }

    renderHeader() {
        return (
            <div className="p-grid p-fluid" style={{ background: '#F4C27A',
                alignItems:  'left' }}>
                <div  className="p-col-6 p-md-6" >
                    <InputText type="search" onInput={e => this.setState({ globalFilter: e.target.value })} placeholder="Buscar por termo, ex: nº da Inscrição" />
                </div>
                <div className="p-col-6 p-md-6">

                </div>
            </div>
        );
    }

    render() {
        const header = this.renderHeader();
        const statusFilter = this.renderStatusFilter();

        return (
            <div>
                <div className={this.state.loading}>
                    <ProgressSpinner style={{ width: '800px',
                        height: '250px' }} strokeWidth="1" fill="#EEEEEE" animationDuration=".5s" />
                </div>
                { this.state.submit !== true ?
                    <DataTable
                        value={this.state.contratos}
                        header={header} ref={el => this.dt = el}
                        dataKey="id"
                        rowHover
                        globalFilter={this.state.globalFilter}
                        selection={this.state.selectedRegistros}
                        onSelectionChange={e => this.setState({ selectedRegistros: e.value })}
                        paginator rows={8}
                        emptyMessage="Nenhum resultado encontrado"
                        currentPageReportTemplate="Mostrando {first} de {last} em {totalRecords}  Registros encontrados"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[8,25,50]}>

                        <Column field="Inscricao" header="Inscrição"></Column>
                        <Column field="Nome" header="Nome"></Column>
                        <Column field="Data" header="Data Venda"></Column>
                        <Column field="DataPagamento" header="DataPagamento"></Column>
                        <Column field="Processo" header="Processo"></Column>
                        <Column field="status" header="Status" body={this.statusBodyTemplate} sortable filter filterElement={statusFilter} />

                    </DataTable> :
                    null }
            </div>
        );
    }
}

export default ContratosRecebidos;
